/** Utah's words for surfaces.ts. */
export const SURFACES_UT = {
  /** Food Code 5-203.15 (backflow prevention on carbonators / plumbed machines) as Utah amends it (R392-100-4). */
  backflowCite: "Food Code 5-203.15 (Utah amendment)",
  /** Food Code 5-402.11 (indirect drain / air gap) as Utah amends it (R392-100-4). */
  airGapCite: "Food Code 5-402.11 (Utah amendment)",
  /** Descale timing note: Utah's water is hard. */
  descaleWhen: "Descale as the maker says (often monthly with hard Utah water)",
  /** Thermometer boiling-water check: Utah's altitude means water boils near 203°F, not 212°F. */
  boilingCheckDont: "Don't use the boiling-water check in Utah (water boils near 203°F).",
} as const;
